import env from "../../shared/const";
import {SUBDOMAIN} from "../const";

/**
 * Basis-URL des Backends je Umgebung. In der Entwicklung leer: der Webpack-Dev-Server
 * proxyt `/graphql` und `/api` auf das lokale Backend.
 */
export const getApiBaseUrl = (): string => {
    if (SUBDOMAIN === "stage") {
        return "https://api.stage.kursorganizer.com";
    }
    if (env.IS_PRODUCTION) {
        return "https://api.kursorganizer.com";
    }
    if (env.IS_STAGING) {
        return "https://api.stage.kursorganizer.com";
    }

    return "";
};

/**
 * Für Ressourcen, die der Browser direkt lädt (`<img>`), am Hostnamen festgemacht:
 * Das Prod-Bundle läuft ohne `NODE_ENV=production`, `getApiBaseUrl()` liefert dort ""
 * und Nginx leitet auf dem App-Host nur `/graphql` weiter, nicht `/api` (#1175).
 */
export const getPublicApiBaseUrl = (hostname: string = window.location.hostname): string => {
    if (hostname === "app.kursorganizer.com") {
        return "https://api.kursorganizer.com";
    }
    if (hostname === "stage.kursorganizer.com") {
        return "https://api.stage.kursorganizer.com";
    }

    return getApiBaseUrl();
};

/** Öffentliches, verkleinertes Firmenlogo für die Login-Seite (#1175). */
export const getCompanyLogoUrl = (koOrganizationId: string): string => `${getPublicApiBaseUrl()}/api/public/company-logo/${koOrganizationId}`;
